import { Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { H2 } from 'components/new-ui/base/typography/styles';
import { SectionContainer } from 'views/customers/components/styles';

type Props = {
    name: string;
    email: string;
};

const ContactDetails = ({ name, email }: Props) => {
    return (
        <SectionContainer>
            <Space size={4} style={{ width: '100%' }}>
                <UserOutlined style={{ color: 'var(--brand-6)', fontSize: 20 }} />
                <H2>Contact Details</H2>
            </Space>

            <Space direction="vertical" size={0} style={{ marginTop: 12 }}>
                <div>
                    <strong>Name:</strong> {name}
                </div>
                <div>
                    <strong>Email:</strong> {email}
                </div>
            </Space>
        </SectionContainer>
    );
};

export default ContactDetails;
